import HttpClient from "../../HttpClient";
import apiRoutes from "../../Routes/Routes.json";

const routes = apiRoutes.SupplyManagement;
const endpoint = (route: string) => `/${route}`;

const SupplyManagmentService = {
  saveOrder: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.SaveOrder), payload);
  },

  saveShippingDetails: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.SaveShippingDetail), payload);
  },

  saveRejectionDetail: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.SaveRejectionDetail), payload);
  },

  restoreDetail: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.RestoreDetail), payload);
  },

  getOrders: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.GetOrders), payload);
  },

  getOrderById: (id: number | string) => {
    return HttpClient().get(`${endpoint(routes.GetSupplyOrderById)}?Id=${id}`);
  },

  getSupplyItemDescriptionById: (id: number | string) => {
    return HttpClient().get(
      `${endpoint(routes.GetSupplyItemDescriptionById)}?Id=${id}`
    );
  },

  getFacilityById: (id: number | string) => {
    return HttpClient().get(`${endpoint(routes.GetFacilityById)}/${id}`);
  },

  exportOrdersToExcel: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.ExportOrders), payload);
  },

  getSupplyItemsLookup: (itemType: string) => {
    return HttpClient().get(
      `${endpoint(routes.GetSupplyItemsLookup)}?itemType=${encodeURIComponent(
        itemType
      )}`
    );
  },

  getStatesLookup: () => {
    return HttpClient().get(endpoint(routes.GetStatesLookup));
  },

  getOrderActionLookup: () => {
    return HttpClient().get(endpoint(routes.GetOrderActionLookup));
  },

  updateOrderAction: (payload: { orderId: number; actionId: number }) => {
    return HttpClient().put(endpoint(routes.UpdateOrderAction), payload);
  },

  getBarcodeTracking: (payload: unknown) => {
    return HttpClient().post(endpoint(routes.GetBarcodeTracking), payload);
  },

  getBarcodesByOrderId: (payload: { supplyOrderId: number }) => {
    return HttpClient().post(endpoint(routes.GetBarcodesByOrderId), payload);
  },

  getSupplyPrinterContent: (payload: {
    printerId: number;
    supplyOrderId: number | null;
    supplyItemId?: number | null;
    kitName: string;
    barcode: string;
  }) => {
    return HttpClient().post(endpoint(routes.GetSupplyPrinterContent), payload);
  },

  validateBarcode: (payload: { facilityId: number; barcode: string }) => {
    return HttpClient().put(endpoint(routes.ValidateBarcode), payload);
  },
};

export default SupplyManagmentService;
